import api from './index.js'

/**
 * 관리자 로그인 API
 * @param {{ branchType: 'HQ'|'DIRECT'|'AGENCY'|'FRANCHISE', loginId: string, password: string }} params
 */
export function signIn(params) {
  return api.post('/api/v1/auth/sign-in', params)
}

/**
 * @param {string} refreshToken
 */
export function refreshToken(refreshToken) {
  return api.post('/api/v1/auth/refresh', { refreshToken })
}
